import { CandidateType, GRADE_OPTIONS } from "constants/global";
import dayjs from "dayjs";
import { Trial_Status } from "@generated/graphql";
import { CompetencyMapOptionList } from "pages/Testing/view/types";
import { getPersonalExaminationLink } from "helpers/index";
import { getExaminationIsExtendedReport } from "pages/Testing/view/helpers";
import { ICandidateItem, InfoInputs, Trial } from "../types";

const useInitTrialForm = (
  trial: Trial,
  competencyMap: NonNullable<CompetencyMapOptionList>[number] | undefined
): InfoInputs => {
  const companyCandidate = trial?.companyCandidate;
  const candidateUsername = companyCandidate?.candidateUsername;
  const comment = trial?.comment;
  const title = trial?.examination.title;
  const trialStatusHistory = trial?.trialStatusHistory;
  const completedAt = trial?.completedAt;
  const phoneNumber = candidateUsername?.candidate?.phoneNumber?.replace("+", "") || "";

  const getTelegramUserName = () => {
    const telegramUsername = candidateUsername?.telegramUsername;
    if (telegramUsername) {
      return `@${telegramUsername}`;
    }
    return "";
  };

  const candidateData: ICandidateItem | null = companyCandidate
    ? {
        id: companyCandidate.id || "",
        fullName: companyCandidate.fullName || "",
        telegramUsername: getTelegramUserName(),
        phoneNumber,
        email: companyCandidate.email,
        position: companyCandidate.position,
        organization: companyCandidate.organization,
        grade: companyCandidate.grade,
        login: companyCandidate.candidateUsername?.login,
      }
    : null;

  const startedAt = trialStatusHistory?.find((history) => history.newStatus === Trial_Status.Started)?.createdAt;
  const login = candidateUsername?.login;
  const createdAt = trial?.createdAt;

  let assessmentLink;
  if (trial?.id) {
    assessmentLink = getPersonalExaminationLink(trial.id, login);
  }

  return {
    id: trial?.id || "",
    createdAt: createdAt ? dayjs(createdAt).format("DD.MM.YYYY HH:mm") : "",
    competencyMap: competencyMap
      ? {
          id: competencyMap.id || "",
          title: competencyMap.title || "",
        }
      : null,
    competencyMapComment: competencyMap?.comment || "",
    competencyMapGrades: competencyMap?.grades?.join(", ") || "",
    link: assessmentLink,
    candidateType: login ? CandidateType.Login : CandidateType.Telegram,
    candidate: {
      id: companyCandidate?.id || "",
      fullName: candidateData,
      grade: GRADE_OPTIONS?.find((grade) => companyCandidate?.grade === grade.id) || null,
      telegramUsername: candidateData,
      phoneNumber: candidateUsername?.candidate?.phoneNumber?.replace("+", "") || "",
      email: companyCandidate?.email || "",
      organization: companyCandidate?.organization,
      position: companyCandidate?.position,
      login: candidateData,
    },
    title,
    comment,
    isSendResult: trial?.examination.isSendResult === undefined ? true : trial?.examination.isSendResult,
    isExtendedReport: getExaminationIsExtendedReport(trial?.examination.sendResultType),
    completedAt: completedAt ? dayjs(completedAt).format("DD.MM.YYYY HH:mm") : "",
    startedAt: startedAt ? dayjs(startedAt).format("DD.MM.YYYY HH:mm") : "",
  };
};

export default useInitTrialForm;
